import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import TableComponent from 'UiKit/table-component';
import { Condition } from 'Component/others';
import useGetRole from 'Domain/role/useGetRole';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import { useRoleState } from 'View/role/state';
import TableSkeleton from 'View/role/components/table-skeleton';

import buildTableList from './const';
import styles from './styles.module.css';

const Table = () => {
  const { t } = useTranslation('role');
  const accessPermission = getMenuPermissions('master-data', 'access');
  const navigate = useNavigate();
  const { filterState, updateFilterState } = useRoleState();
  const { data, isFetching } = useGetRole(filterState);

  const onChangePagination = (data) => updateFilterState({ page: data });
  const onChangeSort = (data) => updateFilterState({ sort: data });

  const tableList = buildTableList(t);

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            isCanCreate={accessPermission?.isCanCreate}
            columns={tableList}
            tableName="table__role"
            dataSource={data?.roles}
            onSort={onChangeSort}
            sortingData={filterState?.sort}
            emptyActionText={t('createButton')}
            isDataExist={data?.isDataExist}
            onEmptyStateAction={() => navigate(`/master-data/access/upsert`)}
            maxTableHeight="calc(100vh - 305px)"
            maxTableBodyHeight="calc(100vh - 404px)"
            tableComponentHeight="calc(100vh - 236px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

const MemoizedTable = ({ ...props }) => useMemo(() => <Table {...props} /> /* eslint-disable */, []);

export default MemoizedTable;